<template>
  <div>
    <el-form ref="formData" :model="formData" :rules="rules">
      <el-row :gutter="20"></el-row>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('label_supplier') || '所属供应商'"
                prop="scmCode"
              >
                <dict-select
                  disabled
                  clearable
                  filterable
                  v-model="formData.scmCode"
                  size="medium"
                  url="/digitalCenter/common/dict/scmInfoDict"
                ></dict-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-upload
                class="contacts-uploader"
                action="/oss/ossUploadReturnUrlAndFileId"
                :show-file-list="false"
                :data="fileData"
                :headers="fileHeaders"
                :on-success="handleSuccess"
                :before-upload="beforeUpload"
                :disabled="disabled"
              >
                <img
                  v-if="formData.contactNameCardUrl1"
                  :src="formData.contactNameCardUrl1"
                  class="contactsEvent"
                />
                <i v-else class="el-icon-plus contactsEvent-uploader-icon"></i>
              </el-upload>
              <div class="mt-2">
                <span>只能上传jpg/png文件，建议文件大小不超过1.5M</span>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="16">
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$l('contact_label_contactName') || '姓名'"
                prop="contactName"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactName"
                  maxlength="50"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                :label="$l('contact_label_contactMobile') || '手机号码'"
                prop="contactMobile"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactMobile"
                  maxlength="50"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item
                :label="$l('contact_label_contactJob') || '职务'"
                prop="contactJob"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactJob"
                  maxlength="50"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="16">
              <el-form-item
                :label="$l('contact_label_contactEmail') || 'Email'"
                prop="contactEmail"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactEmail"
                  maxlength="50"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('contact_label_contactPhone') || '固定电话'"
                prop="contactPhone"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.contactPhone"
                  maxlength="50"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('contact_label_companyName') || '公司名称'"
                prop="companyName"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.companyName"
                  maxlength="500"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item
                :label="$l('contact_label_companyAddress') || '地址'"
                prop="companyAddress"
              >
                <el-input
                  :disabled="disabled"
                  v-model="formData.companyAddress"
                  maxlength="500"
                  :placeholder="$l('INDEX.tips_no_data') || '暂无数据'"
                  clearable
                  size="medium"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <div class="d2-mt d-flex justify-content-end" v-if="!disabled">
        <el-row>
          <el-col :span="24">
            <el-button @click="save" type="primary" size="small">
              {{ $l('INDEX.btn_save') || '保存' }}
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>
<script>
import util from '@/libs/util'
export default {
  props: {
    addType: String
  },
  components: {},
  data() {
    return {
      disabled: false,
      formData: {},
      fileData: {
        // abs文件上传参数
        expirationsec: 0,
        fileproperty: 'publicfiles'
      },
      fileHeaders: {
        // 文件上传请求头
        tokenTimeOut: 0,
        token: util.token.getToken()
      },
      rules: {
        contactName: [
          { required: true, message: '请输入联系人姓名', trigger: 'blur' }
        ],
        contactJob: [
          { required: true, message: '请输入联系人职位', trigger: 'blur' }
        ],
        contactMobile: [
          { required: true, message: '请输入联系人移动电话', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        companyAddress: [
          { required: true, message: '请输入公司地址', trigger: 'blur' }
        ]
      },
      options: {
        lock: true,
        text: 'Loading',
        background: 'rgba(0,0,0,0.1)'
      }
    }
  },
  methods: {
    init(formData) {
      this.$refs.formData.resetFields()
      this.formData = formData
      if (formData.type === 'add') {
        this.disabled = false
      } else if (formData.type === 'view') {
        this.disabled = true
        this.detail()
      }
    },
    beforeUpload() {
      this.$loading(this.options)
      return true
    },
    handleSuccess(res) {
      if (res.status === 200) {
        this.formData.contactNameCardCode1 = res.body.fileId
        this.formData.contactNameCardUrl1 = res.body.url
        // 名片OCR
        this.businessCardUrl(this.formData.contactNameCardUrl1)
      }
    },
    save() {
      if (this.addType === 'supplier') {
        this.saveJump()
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            if (this.formData.type === 'add') {
              this.$api.scmInfoUserContactsSaveApi(this.formData).then(() => {
                this.$message({
                  showClose: true,
                  message: this.$l('INDEX.tips_save_ok') || '保存成功',
                  type: 'success'
                })
                this.$emit('success')
                this.$emit('addNewCancel')
              })
            } else if (this.formData.type === 'update') {
              // this.$api.scmInfoContactsUpdateApi(this.formData).then(() => {
              //   this.$message({
              //     showClose: true,
              //     message: '保存成功',
              //     type: 'success',
              //   })
              //   this.$emit('addNewSuccess')
              //   this.$emit('addNewCancel')
              // })
            }
          } else {
            return false
          }
        })
      }
    },
    saveJump() {
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          if (this.formData.type === 'add') {
            this.$emit('addNewCancel')
            this.$api.scmInfoUserContactsSaveApi(this.formData).then((res) => {
              this.$message({
                showClose: true,
                message: this.$l('INDEX.tips_save_ok') || '保存成功',
                type: 'success'
              })
              // 跳转
              let params = {
                pageType: 'edit',
                scmCode: res.body,
                diversity: 'ordinary',
              }
              this.$router.push({
                name: 'resourceManagement-scmInfoTemp',
                params: params
              })
            })
          }
        } else {
          return false
        }
      })
    },
    detail() {
      let param = {
        scmInfoUserContactsCode: this.formData.scmInfoUserContactsCode
      }
      this.$api.scmInfoUserContactsDetailApi(param).then((res) => {
        this.formData = res.body
      })
    },
    // 名片OCR
    businessCardUrl(imageUrl) {
      this.$api
        .businessCardUrlApi({
          imageUrl: imageUrl
        })
        .then((res) => {
          if (res.body.success) {
            let resData = res.body
            //设置姓名
            this.$set(this.formData, 'contactName', resData.name)
            //设置职务
            this.$set(
              this.formData,
              'contactJob',
              this.arrayToString(resData.title)
            )
            //手机号码
            this.$set(
              this.formData,
              'contactMobile',
              this.arrayToString(resData.tel_cell)
            )
            //固定电话
            this.$set(
              this.formData,
              'contactPhone',
              this.arrayToString(resData.tel_work)
            )
            //email
            this.$set(
              this.formData,
              'contactEmail',
              this.arrayToString(resData.email)
            )
            //公司名称
            this.$set(
              this.formData,
              'companyName',
              this.arrayToString(resData.company)
            )
            //公司地址
            this.$set(
              this.formData,
              'companyAddress',
              this.arrayToString(resData.addr)
            )
          }
          this.$loading(this.options).close()
        })
        .catch(() => {
          this.$loading(this.options).close()
        })
    },
    // 设置内容拼接成string
    arrayToString(array) {
      let str = ''
      array.forEach((item) => {
        if (str) {
          str = str + ',' + item
        } else {
          str = item
        }
      })
      // str = str.substring(0, str.length - 1);
      return str
    }
  }
}
</script>
<style lang="scss" scoped>
.contacts-uploader {
  border: 1px dashed #d9d9d9;
  width: 306px !important;
  height: 204px;
  line-height: 204px !important;
  text-align: center;
}
.contactsEvent-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 306px !important;
  height: 204px;
  line-height: 204px !important;
  text-align: center;
}
.contactsEvent {
  width: 306px !important;
  height: 204px;
  display: block;
}
</style>
